import React from 'react';
import { ReactComponent as EyeWatermark } from '../../assets/images/icons/eyeWatermark.svg';

export default function EyeWatermarkIcon(props) {
  return (
    <EyeWatermark className={`icon ${props.className}`} />
  );
}
